// import Popper


// import required js-files Bootstrap 5

// Import other js-files
// LOS-859: the page header is `position: fixed`, so anything that parks a scroll target at the top
// of the viewport parks it underneath the header. `scroll-padding-top` in custom.scss keeps jumps
// clear of it — but only if it knows how tall the header is, and that is not a constant. The header
// grows by 27px whenever a main-menu label wraps to a second row, which depends on the labels the
// editors picked: www.los.de is 120px wide-screen today while www.qalos.de, with the same markup
// and longer working titles, is 147px. Rechtschreibtest has a shorter header again.
//
// So measure it rather than hard-code it. The stylesheet keeps a deliberately generous fallback for
// the case where this never runs.
(function () {
    var header = document.querySelector('header.los_pos-fixed');

    if (!header) {
        return;
    }

    // The header's own box is a hardcoded 40px, and the logo, the hotline pill and the open nav bar
    // all hang below it. What decides the offset is how far down the page the header actually
    // paints, so walk the subtree — skipping what is invisible, or the closed mobile menu would
    // count: it keeps its children at full size and only hides them with `opacity: 0`, which would
    // report a 205px header on a phone.
    function paintedBottom(node, bottom) {
        for (var i = 0; i < node.children.length; i++) {
            var child = node.children[i];
            var style = window.getComputedStyle(child);

            if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) {
                continue;
            }

            var rect = child.getBoundingClientRect();

            if (rect.width > 0 && rect.height > 0) {
                bottom = Math.max(bottom, rect.bottom);
            }

            bottom = paintedBottom(child, bottom);
        }

        return bottom;
    }

    function measure() {
        var bottom = paintedBottom(header, header.getBoundingClientRect().bottom);

        document.documentElement.style.setProperty('--los-header-height', Math.round(bottom) + 'px');
    }

    measure();

    // The header element itself never changes size — its children do, when a breakpoint or a menu
    // edit makes the labels wrap — so watch the nav as well.
    if (window.ResizeObserver) {
        var observer = new ResizeObserver(measure);

        observer.observe(header);

        var nav = header.querySelector('nav');

        if (nav) {
            observer.observe(nav);
        }
    } else {
        window.addEventListener('resize', measure);
    }

    // A page opened straight on a fragment has already been scrolled by the time the webfonts
    // settle, and they decide where the menu labels wrap — so the height this script reported
    // during parsing can be one 27px row short of the final one, which puts the heading back under
    // the header. Re-measure when everything is in and, if the target ended up behind the header,
    // scroll it clear. Only ever corrects a target that is actually hidden: landing a little low is
    // whitespace, and yanking the page under someone who has started reading is not.
    var userTookOver = false;

    ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
        window.addEventListener(type, function () {
            userTookOver = true;
        }, { once: true, passive: true });
    });

    window.addEventListener('load', function () {
        measure();

        if (userTookOver || window.location.hash.length < 2) {
            return;
        }

        var target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));

        if (!target) {
            return;
        }

        var offset = parseFloat(window.getComputedStyle(document.documentElement).scrollPaddingTop);

        if (target.getBoundingClientRect().top < offset - 1) {
            target.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
    });
})();
$(function() {

    $(window).on('load', function(e) {
        var url = window.location.href;
        var hash = url.substring(url.indexOf('#')); // '#foo'

        if(url.indexOf('#partnerKontaktformularGeneral') >= 0){
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.breadcrumb').offset().top
            }, 2);
            $('.contactform .los_accordion-header').trigger('click')
        }
        if(url.indexOf('#partnerJobsuche') >= 0){
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.breadcrumb').offset().top
            }, 2);
            $('.jobform .los_accordion-header').trigger('click')
        }
    });

    $('form').parsley();

    $('.los_news-section .termine .teaser-text p, ' +
        '.los_news-section .presse .teaser-text p, ' +
        '.los_bodytext-readmore, ' +
        '.los_news-section .aktuelles .teaser-text p').readmore({
        moreLink: '<a href="#" class=""><i class="fas fa-angle-double-right me-1"></i> Erfahren Sie mehr</a>',
        lessLink: '<a href="#" class=""><i class="fas fa-angle-double-up me-1"></i> Schließen</a>',
        collapsedHeight: 66,
        speed: 200,
    });

    // WINDOW CLICK EVENT
    $(window).on('click', function(e) {
        // Read more button for news section
        if (e.target.classList.contains('los_news-card--link')) {
            let parentEl = $(e.target).parent()
            if (parentEl.hasClass('readmore')) {
                parentEl.removeClass('readmore').find('.los_news-card--description').css("height", '66px')
            } else {
                parentEl.addClass('readmore').find('.los_news-card--description').css("height", e.target.previousSibling.previousSibling.scrollHeight)
            }
        }
    });

    // WINDOW RESIZE EVENT
    $(window).resize(function () {
        if (window.innerWidth > 991) {
            $('#navbarMenu').removeClass('active');
            $('#navbarBtn').removeClass('active');
        }
    });

    // MOBILE MENU
    $('#navbarBtn').on('click', function () {
        $('#navbarMenu').toggleClass('active');
        $('#navbarBtn').toggleClass('active');
    });

    $('.los_submenu_handler').on('click', function () {
        $toggle = $(this).parent('.los_nav-item').toggleClass('open');
        $('.los_nav-item').not($toggle).removeClass('open');
    });

    $('.los_sub-submenu_handler').on('click', function () {
        $toggle = $(this).parent('.los_nav-subitem').toggleClass('open');
        $('.los_nav-subitem').not($toggle).removeClass('open');
    });

    // Accordion
    $('.los_accordion-header').on('click', function (e) {
        $('.los_accordion-item').find('.los_accordion-content').stop().slideUp();
        $(this).closest('.los_accordion-item').toggleClass('active').find('.los_accordion-content').stop().slideToggle();
    });

    $(document).on('spinner.trigger.on', '.loading-spinner', function () {
        console.log('spinner.trigger.on');
        $(this).addClass('loading-spinner--is-visible');
    });

    $(document).on('spinner.trigger.off', '.loading-spinner', function () {
        console.log('spinner.trigger.off');
        $(this).removeClass('loading-spinner--is-visible');
    });

    // Check if slider is hidden on mobile, then add padding on content
    /*
    var heightSlider = $('.los_hero-image').height();
    var heightSlider2 = $('.los_hero-image-2').height();
    if (heightSlider <= 40 || heightSlider2 <= 40){
        $('section.content').addClass('los_add_top_padding');
    }
    */

    function deUmlaut(value) {
        value = value.toLowerCase();
        value = value.replace(/ä/g, 'ae');
        value = value.replace(/ö/g, 'oe');
        value = value.replace(/ü/g, 'ue');
        value = value.replace(/ß/g, 'ss');
        value = value.replace(/ /g, '-');
        value = value.replace(/\./g, '');
        value = value.replace(/,/g, '');
        value = value.replace(/\(/g, '');
        value = value.replace(/\)/g, '');
        value = value.replace(/\?/g, '');
        value = value.replace(/\!/g, '');
        return value;
    }

    // Add functionality for CSS carousel
    $('.los_carousel .slide-container').each(function () {
        var indexOfIt = $(this).index() + 1;
        if (indexOfIt == 1) {
            $(this).before('<input type="radio" name="radio-buttons" id="img-' + indexOfIt + '" checked />');
        } else {
            $(this).before('<input type="radio" name="radio-buttons" id="img-' + indexOfIt + '"/>');
        }
        $('.los_carousel .los_carousel-slides .carousel-dots').append('<label for="img-' + indexOfIt + '" class="carousel-dot" id="img-dot-' + indexOfIt + '"></label>');
    });

    // Readmore Mask
    $('.los-readmore-bodytext-2').readmore({
        moreLink: '<button class="btn-readmore"><i class="fas fa-angle-double-right me-1"></i> Erfahren Sie mehr</button>',
        lessLink: '<button class="btn-readmore"><i class="fas fa-angle-double-up me-1"></i> Schließen</button>',
        collapsedHeight: 0,
        speed: 200,
    });
});
// Bootstrap's carousel shows nothing until one .carousel-item is active. t3sbootstrap activates
// `.carousel-inner .carousel-item:first-child` (Partials/Page/Assets.fluid.html), which misses as
// soon as anything precedes the first slide — e.g. the <span class="t3sbs-anchor"> that
// tt_content.stdWrap.prepend renders for a slide with an anchor. Activate the first slide of every
// carousel that has none, whatever sits in front of it. Runs before Bootstrap's own data-api init
// (window load), so the carousel starts cycling from a real slide.
(function () {
    function activateFirstSlides() {
        document.querySelectorAll('.carousel .carousel-inner').forEach(function (inner) {
            if (inner.querySelector('.carousel-item.active')) {
                return;
            }
            var firstSlide = inner.querySelector('.carousel-item');
            if (firstSlide) {
                firstSlide.classList.add('active');
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', activateFirstSlides);
    } else {
        activateFirstSlides();
    }
})();
/*!
 * @preserve
 *
 * Readmore.js jQuery plugin
 * Author: @jed_foster
 * Project home: http://jedfoster.github.io/Readmore.js
 * Licensed under the MIT license
 *
 * Debounce function from http://davidwalsh.name/javascript-debounce-function
 */

/* global jQuery */

(function(factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function($) {
    'use strict';

    var readmore = 'readmore',
        defaults = {
            speed: 100,
            collapsedHeight: 200,
            heightMargin: 16,
            moreLink: '<a href="#">Read More</a>',
            lessLink: '<a href="#">Close</a>',
            embedCSS: true,
            blockCSS: 'display: block; width: 100%;',
            startOpen: false,

            // callbacks
            blockProcessed: function() {},
            beforeToggle: function() {},
            afterToggle: function() {}
        },
        cssEmbedded = {},
        uniqueIdCounter = 0;

    function debounce(func, wait, immediate) {
        var timeout;

        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (! immediate) {
                    func.apply(context, args);
                }
            };
            var callNow = immediate && !timeout;

            clearTimeout(timeout);
            timeout = setTimeout(later, wait);

            if (callNow) {
                func.apply(context, args);
            }
        };
    }

    function uniqueId(prefix) {
        var id = ++uniqueIdCounter;

        return String(prefix === null ? 'rmjs-' : prefix) + id;
    }

    function setBoxHeights(element) {
        var el = element.clone().css({
                height: 'auto',
                width: element.width(),
                maxHeight: 'none',
                overflow: 'hidden'
            }).insertAfter(element),
            expandedHeight = el.outerHeight(),
            cssMaxHeight = parseInt(el.css({maxHeight: ''}).css('max-height').replace(/[^-\d\.]/g, ''), 10),
            defaultHeight = element.data('defaultHeight');

        el.remove();

        var collapsedHeight = cssMaxHeight || element.data('collapsedHeight') || defaultHeight;

        // Store our measurements.
        element.data({
            expandedHeight: expandedHeight,
            maxHeight: cssMaxHeight,
            collapsedHeight: collapsedHeight
        })
            // and disable any `max-height` property set in CSS
            .css({
                maxHeight: 'none'
            });
    }

    var resizeBoxes = debounce(function() {
        $('[data-readmore]').each(function() {
            var current = $(this),
                isExpanded = (current.attr('aria-expanded') === 'true');

            setBoxHeights(current);

            current.css({
                height: current.data( (isExpanded ? 'expandedHeight' : 'collapsedHeight') )
            });
        });
    }, 100);

    function embedCSS(options) {
        if (! cssEmbedded[options.selector]) {
            var styles = ' ';

            if (options.embedCSS && options.blockCSS !== '') {
                styles += options.selector + ' + [data-readmore-toggle], ' +
                    options.selector + '[data-readmore]{' +
                    options.blockCSS +
                    '}';
            }

            // Include the transition CSS even if embedCSS is false
            styles += options.selector + '[data-readmore]{' +
                'transition: height ' + options.speed + 'ms;' +
                'overflow: hidden;' +
                '}';

            (function(d, u) {
                var css = d.createElement('style');
                css.type = 'text/css';

                if (css.styleSheet) {
                    css.styleSheet.cssText = u;
                }
                else {
                    css.appendChild(d.createTextNode(u));
                }

                d.getElementsByTagName('head')[0].appendChild(css);
            }(document, styles));

            cssEmbedded[options.selector] = true;
        }
    }

    function Readmore(element, options) {
        this.element = element;

        this.options = $.extend({}, defaults, options);

        embedCSS(this.options);

        this._defaults = defaults;
        this._name = readmore;

        this.init();

        // IE8 chokes on `window.addEventListener`, so need to test for support.
        if (window.addEventListener) {
            // Need to resize boxes when the page has fully loaded.
            window.addEventListener('load', resizeBoxes);
            window.addEventListener('resize', resizeBoxes);
        }
        else {
            window.attachEvent('load', resizeBoxes);
            window.attachEvent('resize', resizeBoxes);
        }
    }


    Readmore.prototype = {
        init: function() {
            var current = $(this.element);

            current.data({
                defaultHeight: this.options.collapsedHeight,
                heightMargin: this.options.heightMargin
            });

            setBoxHeights(current);

            var collapsedHeight = current.data('collapsedHeight'),
                heightMargin = current.data('heightMargin');

            if (current.outerHeight(true) <= collapsedHeight + heightMargin) {
                // The block is shorter than the limit, so there's no need to truncate it.
                if (this.options.blockProcessed && typeof this.options.blockProcessed === 'function') {
                    this.options.blockProcessed(current, false);
                }
                return true;
            }
            else {
                var id = current.attr('id') || uniqueId(),
                    useLink = this.options.startOpen ? this.options.lessLink : this.options.moreLink;

                current.attr({
                    'data-readmore': '',
                    'aria-expanded': this.options.startOpen,
                    'id': id
                });

                current.after($(useLink)
                    .on('click', (function(_this) {
                        return function(event) {
                            _this.toggle(this, current[0], event);
                        };
                    })(this))
                    .attr({
                        'data-readmore-toggle': id,
                        'aria-controls': id
                    }));

                if (! this.options.startOpen) {
                    current.css({
                        height: collapsedHeight
                    });
                }

                if (this.options.blockProcessed && typeof this.options.blockProcessed === 'function') {
                    this.options.blockProcessed(current, true);
                }
            }
        },

        toggle: function(trigger, element, event) {
            if (event) {
                event.preventDefault();
            }

            if (! trigger) {
                trigger = $('[aria-controls="' + this.element.id + '"]')[0];
            }

            if (! element) {
                element = this.element;
            }

            var $element = $(element),
                newHeight = '',
                newLink = '',
                expanded = false,
                collapsedHeight = $element.data('collapsedHeight');

            if ($element.height() <= collapsedHeight) {
                newHeight = $element.data('expandedHeight') + 'px';
                newLink = 'lessLink';
                expanded = true;
            }
            else {
                newHeight = collapsedHeight;
                newLink = 'moreLink';
            }

            // Fire beforeToggle callback
            // Since we determined the new "expanded" state above we're now out of sync
            // with our true current state, so we need to flip the value of `expanded`
            if (this.options.beforeToggle && typeof this.options.beforeToggle === 'function') {
                this.options.beforeToggle(trigger, $element, ! expanded);
            }

            $element.css({'height': newHeight});

            // Fire afterToggle callback
            $element.on('transitionend', (function(_this) {
                return function() {
                    if (_this.options.afterToggle && typeof _this.options.afterToggle === 'function') {
                        _this.options.afterToggle(trigger, $element, expanded);
                    }

                    $(this).attr({
                        'aria-expanded': expanded
                    }).off('transitionend');
                };
            })(this));

            $(trigger).replaceWith($(this.options[newLink])
                .on('click', (function(_this) {
                    return function(event) {
                        _this.toggle(this, element, event);
                    };
                })(this))
                .attr({
                    'data-readmore-toggle': $element.attr('id'),
                    'aria-controls': $element.attr('id')
                }));
        },

        destroy: function() {
            $(this.element).each(function() {
                var current = $(this);

                current.attr({
                    'data-readmore': null,
                    'aria-expanded': null
                })
                    .css({
                        maxHeight: '',
                        height: ''
                    })
                    .next('[data-readmore-toggle]')
                    .remove();

                current.removeData();
            });
        }
    };


    $.fn.readmore = function(options) {
        var args = arguments,
            selector = this.selector;

        options = options || {};

        if (typeof options === 'object') {
            return this.each(function() {
                if ($.data(this, 'plugin_' + readmore)) {
                    var instance = $.data(this, 'plugin_' + readmore);
                    instance.destroy.apply(instance);
                }

                options.selector = selector;

                $.data(this, 'plugin_' + readmore, new Readmore(this, options));
            });
        }
        else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {
            return this.each(function () {
                var instance = $.data(this, 'plugin_' + readmore);
                if (instance instanceof Readmore && typeof instance[options] === 'function') {
                    instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                }
            });
        }
    };

}));
// Validation errors messages for Parsley
// Load this after Parsley

Parsley.addMessages('de', {
  defaultMessage: "Die Eingabe scheint nicht korrekt zu sein.",
  type: {
    email:        "Die Eingabe muss eine gültige E-Mail-Adresse sein.",
    url:          "Die Eingabe muss eine gültige URL sein.",
    number:       "Die Eingabe muss eine Zahl sein.",
    integer:      "Die Eingabe muss eine Zahl sein.",
    digits:       "Die Eingabe darf nur Ziffern enthalten.",
    alphanum:     "Die Eingabe muss alphanumerisch sein."
  },
  notblank:       "Die Eingabe darf nicht leer sein.",
  required:       "Dies ist ein Pflichtfeld.",
  pattern:        "Die Eingabe scheint ungültig zu sein.",
  min:            "Die Eingabe muss größer oder gleich %s sein.",
  max:            "Die Eingabe muss kleiner oder gleich %s sein.",
  range:          "Die Eingabe muss zwischen %s und %s liegen.",
  minlength:      "Die Eingabe ist zu kurz. Es müssen mindestens %s Zeichen eingegeben werden.",
  maxlength:      "Die Eingabe ist zu lang. Es dürfen höchstens %s Zeichen eingegeben werden.",
  length:         "Die Länge der Eingabe ist ungültig. Es müssen zwischen %s und %s Zeichen eingegeben werden.",
  mincheck:       "Wählen Sie mindestens %s Angaben aus.",
  maxcheck:       "Wählen Sie maximal %s Angaben aus.",
  check:          "Wählen Sie zwischen %s und %s Angaben.",
  equalto:        "Dieses Feld muss dem anderen entsprechen."
});

Parsley.setLocale('de');
var losModal = document.getElementById('losModal');
if (losModal) {
    losModal.addEventListener('show.bs.modal', function (event) {
        // Button that triggered the modal
        let button = event.relatedTarget
        // Extract info from data-bs-* attributes
        var formType = button.getAttribute('data-bs-type')
        var partnerIds = button.getAttribute('data-bs-partner-ids')
        var pageId = button.getAttribute('data-bs-page-id')
        // Form type name as modal headline (LOS-527); cleared first so a previously opened
        // form type never shows while the next one loads
        let modalTitle = losModal.querySelector('.modal-title')
        modalTitle.textContent = ''
        var data = {
            id: 3071,
            type: 42,
            modal: 1,
            tx_loslocations_contactform: {
                formType: formType,
                partnerIds: partnerIds,
                pageId: pageId
            }
        }

        // If necessary, you could initiate an AJAX request here
        // and then do the updating in a callback.
        $.ajax({
            url: '/index.php',
            type: 'get',
            data: data,
            beforeSend: function () {
                console.log('beforeSend');
                $('.loading-spinner').trigger('spinner.trigger.on');
            },
            success: function (response) {
                // Add response in Modal body
                console.log('success');
                $('.modal-body').html(response);
                let formTitle = losModal.querySelector('[data-contact-form-title]')
                modalTitle.textContent = formTitle ? formTitle.dataset.contactFormTitle : ''
                $('.loading-spinner').trigger('spinner.trigger.off');
            },
            error: function (response) {
                console.log('error');
                $('.loading-spinner').trigger('spinner.trigger.off');
            }
        });
    });
}
// <los-contactbox> — contact box behaviour (LOS-765)
//
// Light DOM on purpose: the box is styled by main.min.css and the e2e suite selects inside it, so
// a shadow root would cut off both. The element owns exactly one job — turning the contact form
// link into an overlay opener.
//
// Progressive enhancement, and it degrades in the right direction: the pill ships as a real link
// to the contact form page, and the overlay is only taken when Bootstrap and the modal are
// actually there. If either is missing the click is left alone and the browser navigates. That is
// why the button is never hidden and never dead — the previous markup rendered a
// data-bs-toggle button that did nothing at all without JavaScript.
//
// ajax-modal.js stays untouched (see design.md D9): it reads the form parameters off
// event.relatedTarget, so the attributes are mirrored from the host element onto the trigger and
// the modal is opened with the trigger passed along. The outgoing request is unchanged.
//
// No import/export — the file is concatenated by gulp-rigger today and will be pulled in as a
// side-effect module after the Vite swap, unchanged either way.

(function () {
    'use strict';

    var MODAL_ID = 'losModal';
    var TRIGGER_SELECTOR = '[data-contactbox-form]';

    // host attribute -> attribute ajax-modal.js reads off the related target
    var ATTRIBUTE_MAP = {
        'form-type': 'data-bs-type',
        'partner-ids': 'data-bs-partner-ids',
        'page-id': 'data-bs-page-id'
    };

    class LosContactBox extends HTMLElement {
        connectedCallback() {
            var trigger = this.querySelector(TRIGGER_SELECTOR);
            if (!trigger || this.dataset.contactboxReady === '1') {
                return;
            }

            Object.keys(ATTRIBUTE_MAP).forEach(function (hostAttribute) {
                var value = this.getAttribute(hostAttribute);
                if (value !== null) {
                    trigger.setAttribute(ATTRIBUTE_MAP[hostAttribute], value);
                }
            }, this);

            trigger.addEventListener('click', this.openOverlay);
            this.dataset.contactboxReady = '1';
        }

        openOverlay(event) {
            var modal = document.getElementById(MODAL_ID);

            // No modal on this page, or Bootstrap never loaded: leave the click alone so the link
            // does what a link does. Deliberately checked here and not once at startup — the
            // Bootstrap bundle comes from a CDN and may well arrive after this script.
            if (!modal || !window.bootstrap || !window.bootstrap.Modal) {
                return;
            }

            event.preventDefault();

            // relatedTarget is how ajax-modal.js gets formType/partnerIds/pageId — Bootstrap
            // forwards it into the show.bs.modal event, exactly as the old data-bs-toggle did.
            window.bootstrap.Modal.getOrCreateInstance(modal).show(this);
        }
    }

    if (window.customElements && !window.customElements.get('los-contactbox')) {
        window.customElements.define('los-contactbox', LosContactBox);
    }
})();